const RECENT_KEY = 'recent_searches_v4'
const MAX_RECENT = 12
const DEFAULT_CENTER = [40.2330916, 28.9824323]
const DEFAULT_ZOOM = 12
const TILE_SIZE = 256
const STYLE_ID = 'hm-recent-search-map-style'


function recentI18n(key, fallback, replacements = {}) {
    const table = (window.HOME_RECENT_SEARCH_I18N && typeof window.HOME_RECENT_SEARCH_I18N === 'object')
        ? window.HOME_RECENT_SEARCH_I18N
        : {}

    let value = table
    String(key || '').split('.').forEach(part => {
        value = value && typeof value === 'object' ? value[part] : null
    })

    let text = (typeof value === 'string' && value !== '') ? value : String(fallback || '')

    Object.entries(replacements || {}).forEach(([name, replacement]) => {
        text = text.split(':' + name).join(String(replacement ?? ''))
    })

    return text
}

function currentLocale() {
    return clean(
        window.HOME_RECENT_SEARCH_LOCALE ||
        window.HOME_SEARCH_LOCALE ||
        document.documentElement.lang ||
        'tr'
    ) || 'tr'
}

function formatCount(value) {
    const number = Number(value || 0)
    if (!Number.isFinite(number)) return '0'

    try {
        return number.toLocaleString(currentLocale())
    } catch (e) {
        return number.toLocaleString()
    }
}

function categoryLabelFromParams(params) {
    const map = (window.HOME_RECENT_SEARCH_CATEGORY_MAP && typeof window.HOME_RECENT_SEARCH_CATEGORY_MAP === 'object')
        ? window.HOME_RECENT_SEARCH_CATEGORY_MAP
        : {}

    const categoryId = firstValue(params, ['subcategory_id', 'category_id', 'main_category_id'])
    if (categoryId && clean(map[String(categoryId)])) {
        return clean(map[String(categoryId)])
    }

    return recentI18n('all_listings', 'All Listings')
}

function safeJsonParse(value, fallback) {
    try {
        const parsed = JSON.parse(value)
        return parsed === null || parsed === undefined ? fallback : parsed
    } catch (e) {
        return fallback
    }
}

function clean(value) {
    return String(value ?? '').replace(/\s+/g, ' ').trim()
}

function cleanNumber(value) {
    const num = parseFloat(String(value ?? '').replace(',', '.'))
    return Number.isFinite(num) ? num : null
}

function escapeHtml(value) {
    return clean(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
}

function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value))
}

function toArray(value) {
    return Array.isArray(value) ? value : (value === undefined || value === null || value === '' ? [] : [value])
}

function firstValue(params, keys) {
    for (const key of keys) {
        const value = params?.[key]
        if (Array.isArray(value)) {
            const found = value.find(v => clean(v) !== '')
            if (found !== undefined) return clean(found)
            continue
        }
        if (clean(value) !== '') return clean(value)
    }
    return ''
}

function parseParamsFromHref(href) {
    const out = {}

    try {
        const url = new URL(href || window.location.href, window.location.origin)
        url.searchParams.forEach((value, key) => {
            if (!key || key === 'page' || key === 'include_map') return

            if (out[key] === undefined) {
                out[key] = value
                return
            }

            if (!Array.isArray(out[key])) out[key] = [out[key]]
            out[key].push(value)
        })
    } catch (e) {
        return out
    }

    return out
}

function paramsOf(item) {
    const direct = item?.params || item?.filters || item?.search || {}
    const hrefParams = parseParamsFromHref(item?.href || item?.url || '')
    return Object.assign({}, hrefParams, direct)
}

function stableObject(value) {
    if (!value || typeof value !== 'object') return {}
    const out = {}
    Object.keys(value).sort().forEach(key => {
        const val = value[key]
        if (val === null || val === undefined || clean(val) === '') return
        out[key] = val
    })
    return out
}

function signatureOf(item) {
    const href = clean(item?.href || item?.url)
    const params = stableObject(paramsOf(item))
    const paramSig = Object.keys(params).length ? JSON.stringify(params) : ''
    return clean(item?.signature) || paramSig || href || clean(item?.id) || String(Date.now())
}

function resultCountOf(item) {
    const candidates = [
        item?.total_results,
        item?.totalResults,
        item?.map_preview?.total_results,
        item?.mapPreview?.total_results,
        item?.result_count,
        item?.count,
    ]

    for (const value of candidates) {
        if (value === null || value === undefined || value === '') continue
        const number = Number(value)
        if (Number.isFinite(number)) return number
    }

    return 0
}

function hasPositiveSearchResults(item) {
    return resultCountOf(item) > 0
}

function sameRecentSearch(a, b) {
    if (!a || !b) return false
    const aSignature = clean(a.signature)
    const bSignature = clean(b.signature)
    const aHref = clean(a.href || a.url)
    const bHref = clean(b.href || b.url)

    if (aSignature && bSignature && aSignature === bSignature) return true
    if (aHref && bHref && aHref === bHref) return true

    return false
}

function normalizeSearchItem(item) {
    if (!item || typeof item !== 'object') return null

    const params = paramsOf(item)
    const rebuiltHref = Object.keys(params).length ? buildHrefFromParams(params) : ''
    const href = clean(rebuiltHref || item.href || item.url)

    if (!href && Object.keys(params).length === 0 && clean(item.type) !== 'search') {
        return null
    }

    const now = Date.now()
    const normalized = Object.assign({}, item, {
        type: 'search',
        href,
        url: clean(item.url || href),
        params,
        filters: params,
        search: params,
        signature: signatureOf(item),
        updated_at: Number(item.updated_at || item.created_at_timestamp || now) || now,
        created_at: item.created_at || new Date(now).toISOString(),
    })

    if (!Array.isArray(normalized.tags)) {
        normalized.tags = buildTags(normalized)
    }

    return normalized
}

function buildHrefFromParams(params) {
    const base = window.HOME_RECENT_SEARCH_URL || window.AD_LIST_CONFIG?.searchUrl || window.location.pathname || '/'

    try {
        const url = new URL(base, window.location.origin)
        Object.entries(params || {}).forEach(([key, value]) => {
            if (!key || key === 'page' || key === 'include_map') return
            toArray(value).forEach(v => {
                if (clean(v) !== '') url.searchParams.append(key, clean(v))
            })
        })
        return url.pathname + url.search
    } catch (e) {
        return ''
    }
}

export function readRecentSearches() {
    if (typeof window === 'undefined' || !window.localStorage) return []

    const raw = safeJsonParse(window.localStorage.getItem(RECENT_KEY) || '[]', [])
    if (!Array.isArray(raw)) return []

    const normalized = raw
        .map(normalizeSearchItem)
        .filter(Boolean)
        .filter(hasPositiveSearchResults)
        .sort((a, b) => Number(b.updated_at || 0) - Number(a.updated_at || 0))
        .slice(0, MAX_RECENT)

    if (normalized.length !== raw.length) {
        try {
            window.localStorage.setItem(RECENT_KEY, JSON.stringify(normalized))
        } catch (e) {}
    }

    return normalized
}

export function upsertRecentSearch(item) {
    if (typeof window === 'undefined' || !window.localStorage) return null

    const nextItem = normalizeSearchItem(Object.assign({}, item, {
        updated_at: Date.now(),
        created_at: item?.created_at || new Date().toISOString(),
    }))

    if (!nextItem) return null

    const current = readRecentSearches()

    if (!hasPositiveSearchResults(nextItem)) {
        const cleaned = current.filter(old => !sameRecentSearch(old, nextItem))
        window.localStorage.setItem(RECENT_KEY, JSON.stringify(cleaned))
        return null
    }

    const signature = nextItem.signature
    const href = clean(nextItem.href || nextItem.url)

    const next = [nextItem]
        .concat(current.filter(old => {
            if (!old) return false
            if (signature && old.signature === signature) return false
            if (href && (old.href === href || old.url === href)) return false
            return true
        }))
        .filter(hasPositiveSearchResults)
        .slice(0, MAX_RECENT)

    window.localStorage.setItem(RECENT_KEY, JSON.stringify(next))
    return nextItem
}

export function buildRecentSearchFeed(items = [], tutorialPromos = [], options = {}) {
    const searches = (Array.isArray(items) ? items : [])
        .map(normalizeSearchItem)
        .filter(Boolean)
        .filter(hasPositiveSearchResults)
        .slice(0, MAX_RECENT)

    const promoLimit = Math.max(0, Number(options.maxPromoSlots ?? tutorialPromos.length) || 0)
    const promos = (Array.isArray(tutorialPromos) ? tutorialPromos : [])
        .filter(Boolean)
        .slice(0, promoLimit)
        .map((promo, index) => ({
            type: 'promo',
            id: promo.id || `promo-${index}`,
            title: clean(promo.title) || recentI18n('promo_tip', 'Home.com.tr tip'),
            description: clean(promo.description),
            image: clean(promo.image),
            url: clean(promo.url || '#'),
        }))

    if (!searches.length) return promos

    const usedPromoCount = Math.min(promos.length, Math.max(0, 4 - searches.length))
    return searches.concat(promos.slice(0, usedPromoCount))
}

export function renderRecentSearchMapPreview(container, item) {
    if (!container) return

    ensureStyles()

    const normalized = normalizeSearchItem(item) || item
    renderMiniMap(container, normalized)
}

export function renderRecentSearches(container, feed = []) {
    if (!container) return

    ensureStyles()
    container.innerHTML = ''

    ;(Array.isArray(feed) ? feed : []).forEach((item) => {
        const wrap = document.createElement('div')
        wrap.className = 'slider-list-item hm-recent-search-slider-item'

        if (item?.type === 'promo') {
            wrap.appendChild(renderPromoCard(item))
        } else {
            wrap.appendChild(renderSearchCard(normalizeSearchItem(item)))
        }

        container.appendChild(wrap)
    })
}

function renderPromoCard(item) {
    const href = clean(item.url || '#') || '#'
    const title = clean(item.title) || recentI18n('promo_tip', 'Home.com.tr tip')
    const card = document.createElement('a')
    card.className = 'list-item hm-recent-simple-card hm-recent-promo-card'
    card.href = href

    card.innerHTML = `
        <div class="list-item-photo hm-recent-photo">
            <picture>
                ${item.image
        ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" loading="lazy">`
        : `<span class="hm-recent-placeholder"><i class="ph-light ph-lightbulb"></i></span>`}
            </picture>
        </div>
        <div class="list-item-content">
            <div class="list-item-title">${escapeHtml(title)}</div>
            ${item.description ? `<div class="list-item-tags article hm-recent-desc-simple">${escapeHtml(item.description)}</div>` : ''}
        </div>
    `

    return card
}

function renderSearchCard(item) {
    const href = clean(item?.href || item?.url || '#') || '#'
    const card = document.createElement('a')
    card.className = 'list-item hm-recent-simple-card hm-recent-search-card'
    card.href = href

    const title = searchTitle(item)
    const subtitle = searchSubtitle(item)
    const tags = buildTags(item).slice(0, 4)
    const chips = [...new Set([subtitle, ...tags].map(clean).filter(Boolean))].slice(0, 5)

    card.innerHTML = `
        <div class="list-item-photo hm-recent-photo hm-recent-map-photo">
            <div class="hm-recent-map" aria-label="${escapeHtml(recentI18n('map_preview_aria', ':title map preview', { title }))}">
                <div class="hm-recent-map-loading">${escapeHtml(recentI18n('map_loading', 'Map loading'))}</div>
            </div>
        </div>
        <div class="list-item-content">
            <div class="list-item-title">${escapeHtml(title)}</div>
            ${chips.length ? `<div class="list-item-tags article"><div class="in">${chips.map(chip => `<small>${escapeHtml(chip)}</small>`).join('')}</div></div>` : ''}
        </div>
    `

    const mapEl = card.querySelector('.hm-recent-map')
    requestAnimationFrame(() => renderMiniMap(mapEl, item))

    return card
}

function searchTitle(item) {
    const params = paramsOf(item)
    const transaction = firstValue(params, ['transaction_type']) === '2'
        ? recentI18n('for_rent', 'For Rent')
        : recentI18n('for_sale', 'For Sale')
    const q = firstValue(params, ['q', 'keyword'])
    const category = categoryLabelFromParams(params)

    if (q) {
        return recentI18n('search_with_query', ':transaction search: :query', {
            transaction,
            query: q,
        })
    }

    return recentI18n('search_title', ':transaction :category', {
        transaction,
        category,
    })
}

function searchSubtitle(item) {
    const count = Number(item?.total_results || item?.map_preview?.total_results || 0)

    if (count > 0) {
        return recentI18n('listing_count', ':count listings', {
            count: formatCount(count),
        })
    }

    return ''
}

function buildRangeTag(label, min, max, suffix) {
    min = clean(min)
    max = clean(max)
    if (!min && !max) return ''
    if (min && max) return `${label}: ${min} - ${max}${suffix ? ' ' + suffix : ''}`
    if (min) return `${label}: ${min}+${suffix ? ' ' + suffix : ''}`
    return `${label}: 0 - ${max}${suffix ? ' ' + suffix : ''}`
}

function buildTags(item) {
    const params = paramsOf(item)
    const tags = []
    const location = firstValue(params, ['location_label', 'radius_label']) || clean(item?.map_preview?.location_label)
    const q = firstValue(params, ['q', 'keyword'])
    const minPrice = firstValue(params, ['min_price', 'price_min'])
    const maxPrice = firstValue(params, ['max_price', 'price_max'])
    const minM2 = firstValue(params, ['m2_min'])
    const maxM2 = firstValue(params, ['m2_max'])

    if (location) {
        tags.push(recentI18n('location', 'Location: :value', { value: location }))
    }

    if (q) {
        tags.push(recentI18n('search', 'Search: :value', { value: q }))
    }

    const price = buildRangeTag(recentI18n('price', 'Price'), minPrice, maxPrice, 'TL')
    const area = buildRangeTag(recentI18n('area', 'Area'), minM2, maxM2, 'm²')
    if (price) tags.push(price)
    if (area) tags.push(area)

    if (firstValue(params, ['poly']) || clean(item?.map_preview?.poly)) {
        tags.push(recentI18n('free_draw_area', 'Free-draw area'))
    } else if (firstValue(params, ['bbox']) || clean(item?.map_preview?.bbox)) {
        tags.push(recentI18n('rectangle_draw_area', 'Rectangle draw area'))
    } else if (firstValue(params, ['lat']) && firstValue(params, ['lng'])) {
        tags.push(recentI18n('nearby_search', 'Nearby search'))
    }

    /*
     * Dinamik alan etiketleri server/DOM çevirisinden geldiği için yalnızca
     * kaydedildikleri locale ile mevcut locale aynıysa tekrar kullanılır.
     * Böylece Türkçe oda/özellik etiketi İngilizce/Fransızca karta sızmaz.
     */
    const savedLocale = clean(item?.locale).toLowerCase()
    const activeLocale = currentLocale().toLowerCase()
    if (savedLocale && savedLocale === activeLocale && Array.isArray(item?.dynamic_tags)) {
        item.dynamic_tags.map(clean).filter(Boolean).forEach(tag => tags.push(tag))
    }

    return [...new Set(tags.map(clean).filter(Boolean))].slice(0, 8)
}

function parseBbox(str) {
    const parts = clean(str).split(',').map(v => parseFloat(v))
    if (parts.length !== 4 || parts.some(v => !Number.isFinite(v))) return null
    const [south, west, north, east] = parts
    if (south >= north || west >= east) return null
    return { south, west, north, east }
}

function parsePoly(str) {
    const points = clean(str).split('|').map(pair => {
        const parts = pair.split(',').map(v => parseFloat(v))
        if (parts.length !== 2 || parts.some(v => !Number.isFinite(v))) return null
        return { lat: parts[0], lng: parts[1] }
    }).filter(Boolean)

    return points.length >= 3 ? points : []
}

function normalizePoints(points) {
    return (Array.isArray(points) ? points : [])
        .map(point => {
            const lat = cleanNumber(point?.lat ?? point?.latitude)
            const lng = cleanNumber(point?.lng ?? point?.lon ?? point?.longitude)
            if (lat === null || lng === null) return null
            if (lat < -85 || lat > 85 || lng < -180 || lng > 180) return null
            return { lat, lng }
        })
        .filter(Boolean)
}

function previewOf(item) {
    const params = paramsOf(item)
    const preview = item?.map_preview || item?.mapPreview || {}

    const lat = cleanNumber(preview.lat || firstValue(params, ['lat']))
    const lng = cleanNumber(preview.lng || firstValue(params, ['lng']))
    const center = Array.isArray(preview.default_center) ? preview.default_center : DEFAULT_CENTER

    return {
        bbox: clean(preview.bbox || firstValue(params, ['bbox'])),
        poly: clean(preview.poly || firstValue(params, ['poly'])),
        lat,
        lng,
        radius: cleanNumber(preview.radius || firstValue(params, ['radius'])),
        radius_label: clean(preview.radius_label || firstValue(params, ['radius_label'])),
        points: normalizePoints(preview.points || item?.mapPoints || item?.points || []),
        default_center: [cleanNumber(center[0]) ?? DEFAULT_CENTER[0], cleanNumber(center[1]) ?? DEFAULT_CENTER[1]],
        default_zoom: Number(preview.default_zoom || DEFAULT_ZOOM) || DEFAULT_ZOOM,
        total_results: Number(preview.total_results || item?.total_results || 0) || 0,
        location_label: clean(preview.location_label || item?.location_label || firstValue(params, ['location_label'])),
    }
}

function lonLatToWorld(lat, lng, zoom) {
    const scale = TILE_SIZE * Math.pow(2, zoom)
    const safeLat = clamp(lat, -85.05112878, 85.05112878)
    const sin = Math.sin(safeLat * Math.PI / 180)

    return {
        x: (lng + 180) / 360 * scale,
        y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * scale,
    }
}

function chooseZoom(bounds, width, height) {
    if (!bounds) return DEFAULT_ZOOM

    for (let zoom = 16; zoom >= 4; zoom--) {
        const sw = lonLatToWorld(bounds.south, bounds.west, zoom)
        const ne = lonLatToWorld(bounds.north, bounds.east, zoom)
        const dx = Math.abs(ne.x - sw.x)
        const dy = Math.abs(ne.y - sw.y)

        if (dx <= width * 0.72 && dy <= height * 0.72) return zoom
    }

    return 4
}

function boundsFromPreview(preview) {
    const all = []
    const bbox = parseBbox(preview.bbox)
    const poly = parsePoly(preview.poly)

    preview.points.forEach(point => all.push(point))
    poly.forEach(point => all.push(point))

    if (bbox) {
        all.push({ lat: bbox.south, lng: bbox.west })
        all.push({ lat: bbox.north, lng: bbox.east })
    }

    if (preview.lat !== null && preview.lng !== null) {
        all.push({ lat: preview.lat, lng: preview.lng })
    }

    if (!all.length) {
        all.push({ lat: preview.default_center[0], lng: preview.default_center[1] })
    }

    let south = Math.min(...all.map(p => p.lat))
    let north = Math.max(...all.map(p => p.lat))
    let west = Math.min(...all.map(p => p.lng))
    let east = Math.max(...all.map(p => p.lng))

    const latPad = Math.max((north - south) * 0.22, preview.points.length || bbox || poly.length ? 0.004 : 0.045)
    const lngPad = Math.max((east - west) * 0.22, preview.points.length || bbox || poly.length ? 0.004 : 0.065)

    south = clamp(south - latPad, -85, 85)
    north = clamp(north + latPad, -85, 85)
    west = clamp(west - lngPad, -180, 180)
    east = clamp(east + lngPad, -180, 180)

    return { south, west, north, east }
}

function centerOfBounds(bounds, preview) {
    if (preview.lat !== null && preview.lng !== null && !preview.points.length && !preview.bbox && !preview.poly) {
        return { lat: preview.lat, lng: preview.lng }
    }

    return {
        lat: (bounds.south + bounds.north) / 2,
        lng: (bounds.west + bounds.east) / 2,
    }
}

function cartoBasemapsKey() {
    return clean(window.HOME_CARTO_BASEMAPS_KEY || '')
}

function tileUrl(z, x, y) {
    const max = Math.pow(2, z)
    const wrappedX = ((x % max) + max) % max
    const key = cartoBasemapsKey()
    const base = `https://basemaps.cartocdn.com/rastertiles/light_all/${z}/${wrappedX}/${y}@2x.png`

    return key ? `${base}?key=${encodeURIComponent(key)}` : null
}

function appendCartoAttribution(el) {
    const attribution = document.createElement('div')
    attribution.className = 'hm-recent-map-attribution'
    attribution.innerHTML = '<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">© OpenStreetMap contributors</a> <span>© CARTO</span>'
    el.appendChild(attribution)
}

function renderMiniMap(el, item) {
    if (!el) return

    const preview = previewOf(item)
    const rect = el.getBoundingClientRect()
    const width = Math.max(260, Math.round(rect.width || 310))
    const height = Math.max(150, Math.round(rect.height || 180))
    const bounds = boundsFromPreview(preview)
    const center = centerOfBounds(bounds, preview)
    const zoom = chooseZoom(bounds, width, height)
    const centerWorld = lonLatToWorld(center.lat, center.lng, zoom)
    const topLeft = { x: centerWorld.x - width / 2, y: centerWorld.y - height / 2 }
    const tileMinX = Math.floor(topLeft.x / TILE_SIZE) - 1
    const tileMaxX = Math.floor((topLeft.x + width) / TILE_SIZE) + 1
    const tileMinY = Math.floor(topLeft.y / TILE_SIZE) - 1
    const tileMaxY = Math.floor((topLeft.y + height) / TILE_SIZE) + 1
    const maxTile = Math.pow(2, zoom) - 1

    el.innerHTML = ''
    el.style.setProperty('--hm-map-width', `${width}px`)
    el.style.setProperty('--hm-map-height', `${height}px`)

    const tiles = document.createElement('div')
    tiles.className = 'hm-recent-map-tiles'
    tiles.setAttribute('aria-hidden', 'true')

    for (let x = tileMinX; x <= tileMaxX; x++) {
        for (let y = tileMinY; y <= tileMaxY; y++) {
            if (y < 0 || y > maxTile) continue
            const url = tileUrl(zoom, x, y)
            if (!url) continue

            const img = document.createElement('img')
            img.src = url
            img.loading = 'lazy'
            img.decoding = 'async'
            img.alt = ''
            img.style.left = `${Math.round(x * TILE_SIZE - topLeft.x)}px`
            img.style.top = `${Math.round(y * TILE_SIZE - topLeft.y)}px`
            tiles.appendChild(img)
        }
    }

    el.appendChild(tiles)

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('class', 'hm-recent-map-shape')
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`)
    svg.setAttribute('preserveAspectRatio', 'none')

    drawGeometry(svg, preview, topLeft, zoom, width, height)
    el.appendChild(svg)

    drawPins(el, preview, topLeft, zoom, width, height)
    drawMapBadges(el, preview)
    appendCartoAttribution(el)
}

function projectToScreen(point, topLeft, zoom) {
    const world = lonLatToWorld(point.lat, point.lng, zoom)
    return {
        x: world.x - topLeft.x,
        y: world.y - topLeft.y,
    }
}

function drawGeometry(svg, preview, topLeft, zoom, width, height) {
    const poly = parsePoly(preview.poly)
    const bbox = parseBbox(preview.bbox)

    if (poly.length) {
        const points = poly.map(p => projectToScreen(p, topLeft, zoom))
        const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon')
        polygon.setAttribute('points', points.map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' '))
        polygon.setAttribute('class', 'hm-recent-map-polygon')
        svg.appendChild(polygon)
        return
    }

    if (bbox) {
        const nw = projectToScreen({ lat: bbox.north, lng: bbox.west }, topLeft, zoom)
        const se = projectToScreen({ lat: bbox.south, lng: bbox.east }, topLeft, zoom)
        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
        rect.setAttribute('x', Math.max(-20, Math.min(nw.x, se.x)).toFixed(1))
        rect.setAttribute('y', Math.max(-20, Math.min(nw.y, se.y)).toFixed(1))
        rect.setAttribute('width', Math.min(width + 40, Math.abs(se.x - nw.x)).toFixed(1))
        rect.setAttribute('height', Math.min(height + 40, Math.abs(se.y - nw.y)).toFixed(1))
        rect.setAttribute('rx', '10')
        rect.setAttribute('class', 'hm-recent-map-polygon')
        svg.appendChild(rect)
    }
}

function drawPins(el, preview, topLeft, zoom, width, height) {
    const points = preview.points.slice(0, 42)
    let visible = 0

    points.forEach((point, index) => {
        const screen = projectToScreen(point, topLeft, zoom)
        if (screen.x < -12 || screen.x > width + 12 || screen.y < -12 || screen.y > height + 12) return

        const pin = document.createElement('span')
        pin.className = index < 8 ? 'hm-recent-pin is-strong' : 'hm-recent-pin'
        pin.style.left = `${screen.x}px`
        pin.style.top = `${screen.y}px`
        el.appendChild(pin)
        visible += 1
    })

    // Yakın çevre/radius aramalarında ilan point listesi yoksa merkez noktayı yine kırmızı pin olarak göster.
    if (visible === 0 && preview.lat !== null && preview.lng !== null) {
        const center = projectToScreen({ lat: preview.lat, lng: preview.lng }, topLeft, zoom)

        if (center.x >= -12 && center.x <= width + 12 && center.y >= -12 && center.y <= height + 12) {
            const pin = document.createElement('span')
            pin.className = 'hm-recent-pin is-strong is-center'
            pin.style.left = `${center.x}px`
            pin.style.top = `${center.y}px`
            el.appendChild(pin)
            visible += 1
        }
    }

    if (preview.total_results > visible && preview.total_results > 0) {
        const badge = document.createElement('div')
        badge.className = 'hm-recent-map-count'
        badge.innerHTML = `<strong>${escapeHtml(formatCount(preview.total_results))}</strong><small>${escapeHtml(recentI18n('listing_short', 'listing'))}</small>`
        el.appendChild(badge)
    }
}

function drawMapBadges(el, preview) {
    const hasPoly = !!parsePoly(preview.poly).length
    const hasBbox = !!parseBbox(preview.bbox)

    // Konum hem harita üzerinde hem kart altında tekrar görünmesin.
    // Çizim/bölge filtresi varsa harita üzerinde sadece alan tipini gösteriyoruz;
    // normal konum aramasında üst badge basılmıyor, konum aşağıdaki chip görünümünde kalıyor.
    if (!hasPoly && !hasBbox) return

    const badge = document.createElement('div')
    badge.className = 'hm-recent-map-badges'

    const text = hasPoly
        ? recentI18n('drawing_area', 'Drawing area')
        : recentI18n('selected_area', 'Selected area')
    const icon = hasPoly ? 'ph-fill ph-polygon' : 'ph-fill ph-corners-out'

    badge.innerHTML = `<span><i class="${icon}"></i> ${escapeHtml(text)}</span>`
    el.appendChild(badge)
}

function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return

    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
        #recent-searches-slider[data-native-scroll="1"]{display:flex;gap:20px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-snap-type:x proximity;padding-bottom:4px;}
        #recent-searches-slider[data-native-scroll="1"]::-webkit-scrollbar{height:0;}
        #recent-searches-slider[data-native-scroll="1"] .slider-list-item{flex:0 0 auto;scroll-snap-align:start;}
        .hm-recent-search-slider-item{width:100%;display:inline-block;vertical-align:top;}
        #recent-searches-slider[data-native-scroll="1"] .hm-recent-search-slider-item{width:300px;min-width:300px;}

        .hm-recent-simple-card{display:block;width:100%;height:100%;overflow:hidden;text-decoration:none;background:#fff;border:1px solid #eeeeee;border-radius:16px;box-shadow:none;color:inherit;transition:border-color .16s ease;}
        .hm-recent-simple-card:hover{border-color:#dddddd;box-shadow:none;transform:none;}
        .hm-recent-photo{position:relative;width:100%;height:168px;overflow:hidden;background:#f5f5f5;border-radius:0;}
        .hm-recent-photo picture,.hm-recent-photo picture img{display:block;width:100%;height:100%;}
        .hm-recent-photo picture img{object-fit:cover;}
        .hm-recent-placeholder{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#f6f6f6;color:#da241d;}
        .hm-recent-placeholder i{font-size:42px;}

        .hm-recent-map{position:relative;width:100%;height:100%;overflow:hidden;background:#f2f4f3;isolation:isolate;}
        .hm-recent-map-loading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#777;background:#f4f5f4;}
        .hm-recent-map-tiles{position:absolute;inset:0;z-index:1;}
        .hm-recent-map-tiles img{position:absolute;width:256px;height:256px;max-width:none;user-select:none;pointer-events:none;}
        .hm-recent-map-shape{position:absolute;inset:0;z-index:3;width:100%;height:100%;pointer-events:none;}
        .hm-recent-map-polygon{fill:rgba(218,36,29,.14);stroke:#da241d;stroke-width:2;stroke-linejoin:round;stroke-linecap:round;}
        .hm-recent-pin{position:absolute;z-index:4;width:8px;height:8px;border-radius:999px;background:#da241d;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.22);transform:translate(-50%,-50%);}
        .hm-recent-pin.is-strong{width:10px;height:10px;box-shadow:0 2px 7px rgba(0,0,0,.24);}
        .hm-recent-map-count{position:absolute;right:10px;top:10px;z-index:7;height:30px;padding:0 9px;border-radius:999px;background:rgba(255,255,255,.94);color:#111;display:flex;align-items:center;gap:3px;border:1px solid rgba(0,0,0,.07);}
        .hm-recent-map-count strong{font-size:12px;line-height:1;font-weight:800;}
        .hm-recent-map-count small{font-size:10px;line-height:1;font-weight:700;color:#666;}
        .hm-recent-map-badges{position:absolute;left:10px;right:10px;bottom:22px;z-index:7;display:flex;align-items:center;}
        .hm-recent-map-badges span{max-width:100%;height:26px;padding:0 9px;border-radius:999px;background:rgba(255,255,255,.94);color:#222;display:inline-flex;align-items:center;gap:5px;font-size:11px;font-weight:700;border:1px solid rgba(0,0,0,.07);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
        .hm-recent-map-badges i{font-size:12px;color:#da241d;}
        .hm-recent-map-attribution{position:absolute;right:4px;bottom:3px;z-index:8;padding:2px 4px;border-radius:4px;background:rgba(255,255,255,.82);font-size:8px;line-height:1.2;color:#555;white-space:nowrap;}
        .hm-recent-map-attribution a{color:inherit;text-decoration:none;}
        .hm-recent-map-attribution a:hover{text-decoration:underline;}
        .list-item-tags{min-height:0px;}
        #recent-searches-slider .list-item-tags .in{display:flex;flex-wrap:wrap;gap:6px;}
        #recent-searches-slider .list-item-tags small{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}

        #recent-searches-slider[data-native-scroll="1"]{align-items:stretch;}
        #recent-searches-slider .slick-track{display:flex;align-items:stretch;}
        #recent-searches-slider .slick-slide{height:auto;}
        #recent-searches-slider .slick-slide>div{height:100%;}
        #recent-searches-slider .slider-list-item{height:100%;}
        #recent-searches-slider .hm-recent-photo{flex:0 0 auto;}
        #recent-searches-slider[data-native-scroll="1"] .slider-list-item{display:flex !important;align-items:stretch;}
        .hm-recent-simple-card{display:flex;flex-direction:column;height:100%;}
        .hm-recent-simple-card .list-item-content{flex:1 1 auto;display:flex;flex-direction:column;}
        #recent-searches-slider .list-item-tags{margin-top:auto;}
        #recent-searches-slider .list-item-tags small{font-size:11px;line-height:16px;padding:3px 7px;}
        .hm-recent-desc-simple{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}

        @media (max-width:768px){
            #recent-searches-slider[data-native-scroll="1"] .hm-recent-search-slider-item{width:276px;min-width:276px;}
            .hm-recent-photo{height:154px;}
            .hm-recent-simple-card{border-radius:14px;}
            .hm-recent-simple-card .list-item-content{padding:13px;}
        }
    `
    document.head.appendChild(style);
}
